setPmSectionProcessingAction